import React, { FunctionComponent, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';
import { LanguageContext } from 'context';
import { hasBaseline } from 'utils';
import { LanguageTypes } from 'types/global';

interface OwnProps {
  forcedLang?: LanguageTypes
}

type LinkWrapperProps = JSX.IntrinsicElements['a'] & OwnProps;

const LinkWrapper: FunctionComponent<LinkWrapperProps> = props => {
  const { href, children, className, onClick, forcedLang, ...rest } = props;
  const isInternal = href && href.indexOf('/') === 0;
  const isHash = href && href.indexOf('#') === 0;
  const { language } = useContext(LanguageContext);
  const forcedLanguage = forcedLang || language;
  const fullUrl = `${hasBaseline(forcedLanguage) ? `/${forcedLanguage}` : ''}${href}`;

  if (isInternal) {
    return (
      // @ts-ignore
      <NavLink to={fullUrl} className={className} onClick={onClick} {...rest} children={children} />
    );
  }

  if (isHash) {
    return (
      // @ts-ignore
      <NavHashLink to={fullUrl} className={className} onClick={onClick} {...rest} children={children} />
    );
  }

  // eslint-disable-next-line
  return (
    <a className={className} onClick={onClick} href={href} {...rest}>
      {children}
    </a>
  );
};

export default LinkWrapper;
